const ACCENT_FROM =
  "ÀÁÂÃÄÅàáâãäåÒÓÔÕÖØòóôõöøÈÉÊËèéêëÇçÌÍÎÏìíîïÙÚÛÜùúûüŸÿÑñ";
const ACCENT_TO =
  "AAAAAAaaaaaaOOOOOOooooooEEEEeeeeCcIIIIiiiiUUUUuuuuYYNn";

const accentMap = new Map(
  [...ACCENT_FROM].map((ch, i) => [ch, ACCENT_TO[i] || ch])
);

/** Minúsculas y sin tildes (misma lógica que búsqueda SQL del CRM). */
export function normalizeSearchText(value) {
  return String(value ?? "")
    .normalize("NFC")
    .split("")
    .map((ch) => accentMap.get(ch) ?? ch.toLowerCase())
    .join("");
}

export function textIncludes(haystack, needle) {
  const n = normalizeSearchText(needle);
  if (!n) return true;
  return normalizeSearchText(haystack).includes(n);
}

export function textIncludesAny(values, needle) {
  const n = normalizeSearchText(needle);
  if (!n) return true;
  return values.some((v) => normalizeSearchText(v).includes(n));
}
